export const notificationSchedules = [
  {
    id: 'NS001',
    name: 'Training Not Started — Day 3 Reminder',
    trigger: 'not_started',
    templateId: 'NT001',
    daysAfterAssignment: 3,
    isActive: true,
    recipients: ['learner'],
    description: 'Send if training not started 3 days after assignment',
  },
  {
    id: 'NS002',
    name: 'Due Soon — 7 Days Warning',
    trigger: 'due_soon',
    templateId: 'NT002',
    daysBefore: 7,
    isActive: true,
    recipients: ['learner'],
    description: 'Remind learner 7 days before due date',
  },
  {
    id: 'NS003',
    name: 'Due Soon — 3 Days Warning',
    trigger: 'due_soon',
    templateId: 'NT002',
    daysBefore: 3,
    isActive: true,
    recipients: ['learner'],
    description: 'Remind learner 3 days before due date',
  },
  {
    id: 'NS004',
    name: 'Due Soon — 1 Day Warning',
    trigger: 'due_soon',
    templateId: 'NT002',
    daysBefore: 1,
    isActive: true,
    recipients: ['learner'],
    description: 'Final reminder 1 day before due date',
  },
  {
    id: 'NS005',
    name: 'Overdue — Day 1',
    trigger: 'overdue',
    templateId: 'NT003',
    daysAfterDue: 1,
    isActive: true,
    recipients: ['learner'],
    description: 'Notify learner 1 day after overdue',
  },
  {
    id: 'NS006',
    name: 'Overdue — Manager Escalation (Day 3)',
    trigger: 'manager_escalation',
    templateId: 'NT006',
    daysAfterDue: 3,
    isActive: true,
    recipients: ['manager'],
    description: 'Escalate to manager after 3 days overdue',
  },
  {
    id: 'NS007',
    name: 'Phishing Follow-Up — Immediate',
    trigger: 'phishing_followup',
    templateId: 'NT004',
    daysAfterAssignment: 0,
    isActive: true,
    recipients: ['learner'],
    description: 'Send immediately after phishing failure',
  },
  {
    id: 'NS008',
    name: 'Compliance Deadline — 14 Days',
    trigger: 'compliance_deadline',
    templateId: 'NT005',
    daysBefore: 14,
    isActive: true,
    recipients: ['learner'],
    description: 'Compliance reminder 14 days before deadline',
  },
];